// extracted by mini-css-extract-plugin
export default {"external":"ExternalLink_external__fXHf5"};